import { toast } from "react-toastify";
import { Post, Get } from "../../AxiosCRUDFunctions";
import { apiHeader, BaseURL } from "../../config";
import { getToken } from "../../helpers/tokenStorage";
// src/api/medicineAPI.js
//get all medicine handler
export const fetchMedicineList = async ({
  pageNumber = 1,
  limit = 10,
  sortField = "",
  sortDirection = "desc",
  doctorId = 0,
  locationId = 0,
  medicineId = 0,
  filters = {},
}
) => {
  const response = await Post(
    BaseURL("medicine/get-medicine-list"),
    {
      pageNumber,
      pageSize: 10,
      totalRowsCount: 0,
      sortField,
      sortDirection,
      search: filters?.search || "",
      filter: {
        locationId: filters?.locationId || locationId,
        medicineId,
        doctorId,
        fromDate: filters?.fromDate || "",
        toDate: filters?.toDate || "",
        targetStatus: filters?.targetStatus || "",
        targetFilter: {
          minValue: filters?.targetFilter?.minValue || 0,
          maxValue: filters?.targetFilter?.maxValue || 0
        },
        estimatedFilter: {
          minValue: filters?.estimatedFilter?.minValue || 0,
          maxValue: filters?.estimatedFilter?.maxValue || 0
        }
      },
    },
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) {
    return response?.data?.body;
  } else {
    toast.error(response?.data?.headers?.error);
    return [];
  }
};
//add medicine handler
export const addMedicineToAPI = async (params) => {
  const response = await Post(
    BaseURL("medicine/add-medicine"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error == 200) {
    toast.success("Medicine Created Successfully");
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
//update medicine
export const updateMedicineInAPI = async (params) => {
  const response = await Post(
    BaseURL("medicine/update-medicine"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error == 200) {
    toast.success("Medicine Updated Successfully");
  } else {
    toast.error(response?.data?.headers?.message);
  }
  // return response.data;
};
//delete medicine
export const deleteMedicineFromAPI = async (params) => {
  const response = await Post(
    BaseURL("medicine/delete-medicine"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error == 200) {
    toast.success("Medicine Deleted Successfully");
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
//get Medicine By Id
export const getMedicineByIdFromAPI = async (params) => {
  const response = await Post(
    BaseURL("medicine/get-medicine-byId"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};
//link doctor
export const linkDoctorTargetFromAPI = async (params) => {
  const response = await Post(
    BaseURL("medicine/link-doctor-target"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) {
    toast.success("Doctor Link Successfully");
    return true;
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
//modify target
export const modifyTargetAPI = async (params) => {
  const response = await Post(
    BaseURL("medicine/create-update-medicine-target"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) {
    toast.success("Medicine Prescription Target Update  Successfully");
    //handle get all medicines
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
//close target
export const closeTargetAPI = async (params) => {
  const response = await Post(
    BaseURL("medicine/close-target"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) {
    toast.success(`${params?.medicineName} target close successfully`);
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
//close target
export const closeCreateMedicineTargetAPI = async (params) => {
  const response = await Post(
    BaseURL("medicine/close-create-medicine-target"),
    params,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) {
    toast.success(`${params?.medicineName} target close successfully`);
  } else {
    toast.error(response?.data?.headers?.message);
  }
};
export const getAllMedicineUnitsAndTypeApi = async () => {
  const response = await Promise.allSettled([
    Get(BaseURL("Medicine/get-medicine-unit"), getToken()),
    Get(BaseURL("Medicine/get-medicine-type"), getToken()),
  ]);
  const result = response?.map((api) => api?.value?.data?.body);
  return result;
};

export const getAllMedicineDashboard = async () => {
  const response = await Post(
    BaseURL("medicine/get-medicine-dashboard"),
    {},
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};

export const getMedicineStatisticsApi = async (data) => {
  const response = await Post(
    BaseURL("medicine/get-medicine-statistic"),
    data,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};
